export default "__VITE_PUBLIC_ASSET__fdebeb28__"